import { render, staticRenderFns } from "./signCell.vue?vue&type=template&id=b6565db6&scoped=true"
import script from "./signCell.vue?vue&type=script&lang=js"
export * from "./signCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6565db6",
  null
  
)

export default component.exports